import React from 'react'
import LcsData from './LcsData/LcsData'
import StudentData from '../StudentData/StudentData'

const StudentView = ({ isLoading }) => {
  return (
    <div className='flex gap-2'>
      <StudentData isLoading={isLoading} />
      <LcsData isLoading={isLoading} />
    </div>
  )
}

export default StudentView